import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { Stack } from "expo-router";

export default function UsersLayout() {
  return (
    <Stack screenOptions={{ headerShown: true, header: (props) => <ScreenHeader {...props} /> }} />
  );
}
